module.exports = __webpack_public_path__ + "img/logo-emp.5e3f1210.png";